let html = `<div class="empty-filter">
    <div class="empty-filter__title">{title}</div>
    <div class="empty-filter__subtitle">{text}</div>
    <div class="empty-filter__buttons hide"></div>
    <div class="empty-filter__templates">
        <div class="empty-template">
            <div class="empty-template__ico"></div>
            <div class="empty-template__body"></div>
        </div>
        <div class="empty-template">
            <div class="empty-template__ico"></div>
            <div class="empty-template__body"></div>
        </div>
        <div class="empty-template">
            <div class="empty-template__ico"></div>
            <div class="empty-template__body"></div>
        </div>
    </div>
</div>`

export default html